export default __webpack_public_path__ + "static/media/0xd28449bb9bb659725accad52947677cce3719fd7.6bfd5c59.png";